module.exports = __webpack_public_path__ + "static/media/bin.2a2d1d40.png";